<template>
<div>
<Warnings/>

</div>
</template>
<script>
import Warnings from "../../components/academic/Warnings.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
    Warnings
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>